<template>
  <div class="landing_page">
    <v-navigation-drawer
      right
      absolute
      app
      :disable-resize-watcher="true"
      :disable-route-watcher="true"
      :expand-on-hover="true"
      :permanent="true"
      v-model="sidebarModel"
      ref="sidebar"
      id="landing_side-bar"
    >
      <template v-slot:prepend>
        <v-list-item two-line>
          <v-list-item-icon>
            <v-icon>widgets</v-icon>
          </v-list-item-icon>
        </v-list-item>
      </template>

      <v-divider></v-divider>
      <!--Navigetion drawer dropList-->
      <drop-list
        class="list2"
        :items="itemsToDrag"
        @reorder="$event.apply(itemsToDrag)"
        @insert="insertItemToSidebar"
        mode="cut"
      >
        <template v-slot:item="{ item }">
          <drag
            :key="item.componentName"
            class="sidebar-item"
            :data="item"
            @cut="removeFromSidebar(itemsToDrag, item)"
          >
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-img
                  class="sidebar-item_img"
                  :src="item.componentImg"
                  :width="sidebarImgSize"
                  :height="sidebarImgSize"
                  v-bind="attrs"
                  v-on="on"
                ></v-img>
              </template>
              <span>{{ item.componentName }}</span>
            </v-tooltip>
          </drag>
        </template>
        <template v-slot:feedback="{ data }">
          <div
            class="sidebar-item reordering_sidebar_item"
            :key="data.componentName"
          >
            <v-img
              class="sidebar-item_img"
              :src="data.componentImg"
              :width="sidebarImgSize"
              :height="sidebarImgSize"
            ></v-img>
          </div>
        </template>
        <template v-slot:reordering-drag-image="{ item }">
          <div
            class="sidebar-item inserting_sidebar_item"
            :key="item.componentName"
          >
            <v-img
              class="sidebar-item_img"
              :src="item.componentImg"
              :width="sidebarImgSize"
              :height="sidebarImgSize"
            ></v-img>
          </div>
        </template>
      </drop-list>
    </v-navigation-drawer>
    <v-main class="landing">
      <v-container class="landing_wrapper" fluid>
        <template v-if="widgetsStack.length <= 0">
          <drop
            class="landing_large-widget-row user_warning"
            @drop="dropIntoWidgetsBoard"
            mode="cut"
          >
            <v-col cols="12">
              <h4 style="text-align: center;">
                You need to drop here widget from sidebar
              </h4>
            </v-col>
          </drop>
        </template>
        <template v-else>
          <drop-list
            :items="widgetsStack"
            class="landing_large-widget-row row"
            @insert="insertWidgetToBoard"
            @reorder="$event.apply(widgetsStack)"
            mode="cut"
          >
            <template v-slot:item="{ item }">
              <drag
                :class="getSizeForWidget(item)"
                :key="item.componentName"
                :data="item"
                @cut="removeFromWidgetsBoard(widgetsStack, item)"
              >
                <component :is="item.component"></component>
              </drag>
            </template>
            <template v-slot:feedback="{ data }">
              <v-skeleton-loader
                type="image"
                :key="data.componentName"
                :class="getSizeForLoader(data)"
              />
            </template>
          </drop-list>
        </template>
      </v-container>
    </v-main>
  </div>
</template>

<script>
// We can limit table widgets throught props for correct display
import { Drag, DropList, Drop } from "vue-easy-dnd";
/**
 * Here if we want to add a new widget we need to import this component here and then add object in
 * ../../constants/widgets with full description
 */
//import AthletesBirthday from "../club_management/AthletesBirthday.vue";
import GroupChart from "../club/GroupChart.vue";
import GroupList from "../club/GroupList.vue";
import Records from "../league/Records.vue";
import AthleteList from "../club/AthleteList.vue";
import AthleteRanksResults from "../club/AthleteRanksResults.vue";
import AthleteAttendance from "../club/AthleteAttendance.vue";
import UploadFiles from "../../etl/upload_files.vue";

// storageGetter & storageSetter it is a useful addition for work with localStorage, the main reason is reactivities.
import { storageGetter, storageSetter } from "../../../_helpers";
import { sidebarWidgets } from "../../../constants/widgets";

export default {
  name: "App",
  components: {
    Drag,
    Drop,
    DropList,
    GroupChart,
    GroupList,
    Records,
    AthleteList,
    AthleteRanksResults,
    AthleteAttendance,
    UploadFiles
  },
  data() {
    return {
      widgetsStack: [],
      sidebarImgSize: 50,
      sidebarModel: false,
      itemsToDrag: sidebarWidgets
    };
  },
  computed: {
    sizeImg() {
      if (this.sidebarModel) {
        return this.$refs.sidebar.computedWidth;
      } else {
        return 50;
      }
    }
  },
  watch: {
    sizeImg(value) {
      if (value === 56) {
        this.sidebarImgSize = 50;
      } else if (value > 200) {
        this.sidebarImgSize = 100;
      }
    }
  },
  methods: {
    getSizeForWidget(item) {
      switch (item.componentType) {
        case "mini":
          return "mini-widget col-xs-11 col-md-3 col-xl-4";
        case "middle":
          return "middle-widget col-xs-11 col-md-5";
        case "large":
          return "large-widget col-11";
        default:
          return "large-widget col-11";
      }
    },
    getSizeForLoader(item) {
      switch (item.componentType) {
        case "mini":
          return "col-xs-11 col-md-3 col-xl-4";
        case "middle":
          return "col-xs-11 col-md-5";
        case "large":
          return "col-11";
        default:
          return "col-11";
      }
    },
    removeFromWidgetsBoard(array, value) {
      let index = array.indexOf(value);
      array.splice(index, 1);
      storageSetter("widgetsBoard", this.widgetsStack);
    },
    removeFromSidebar(array, value) {
      let index = array.indexOf(value);
      array.splice(index, 1);
      this.saveSiderbarState();
    },
    insertWidgetToBoard(event) {
      this.widgetsStack.splice(event.index, 0, event.data);
      storageSetter("widgetsBoard", this.widgetsStack);
      this.saveSiderbarState();
    },
    insertItemToSidebar(event) {
      this.itemsToDrag.splice(event.index, 0, event.data);
      this.saveSiderbarState();
    },
    dropIntoWidgetsBoard(event) {
      this.widgetsStack.push(event.data);
      storageSetter("widgetsBoard", this.widgetsStack);
      this.saveSiderbarState();
    },
    saveSiderbarState() {
      storageSetter("sidebarWidgets", this.itemsToDrag);
    }
  },
  mounted() {
    if (storageGetter("widgetsBoard").length > 0)
      this.widgetsStack = storageGetter("widgetsBoard");
    if (storageGetter("sidebarWidgets").length > 0) {
      this.itemsToDrag = storageGetter("sidebarWidgets");
    } else if (
      // Without this condition if storageGetter === 0, sidebarState === fullWidgets.
      storageGetter("sidebarWidgets").length === 0 &&
      storageGetter("widgetsBoard").length > 0
    ) {
      this.itemsToDrag = storageGetter("sidebarWidgets");
    }
  }
};
</script>

<style lang="scss">
html,
body {
  height: 100%;
  font-family: "Roboto";
}

#landing_side-bar {
  height: 100% !important;
  z-index: 2000;
}

.list2 {
  min-height: 25vh;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
}

.sidebar-item {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 10px;
  transition: all 1s;
}

.reordering_sidebar_item {
  border-top: 2px dashed black !important;
  border-bottom: 2px dashed black !important;
  background-color: #fff9c4 !important;
}

.drag-mode-reordering {
  border: 2px dashed black !important;
  background-color: #eeeeee !important;
}

.sidebar-item:hover {
  border: 2px dashed black !important;
}

.drop-allowed {
  background-color: #a5d6a7 !important;
  border: 2px dashed black !important;
}

.drop-forbidden {
  background-color: #ef9a9a !important;
  border: 2px dashed black !important;
}

.landing {
  height: 100%;

  &_mini-widget-row {
    min-height: 23vh;
    border: 2px solid gray;
    border-radius: 10px;
    margin: 10px auto;
    background-color: #eeeeee;
    align-items: center;
    justify-content: center;
  }

  &_large-widget-row {
    min-height: 65.2vh;
    border: 2px solid gray;
    border-radius: 10px;
    margin: 10px auto;
    background-color: #eeeeee;
    align-items: center;
    justify-content: center;
  }

  &_middle-widget-row {
    min-height: 35vh;
    border: 2px solid gray;
    border-radius: 10px;
    margin: 10px auto;
    background-color: #eeeeee;
    align-items: center;
    justify-content: center;
  }
}

.mini-widget {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 25vh;
  overflow: auto;
  background-color: white;
  margin: 10px 25px;
  border: 1px solid gray;
  border-radius: 5px;
}

.middle-widget {
  height: 35vh;
  overflow: auto;
  background-color: white;
  margin: 10px 25px;
  border: 1px solid gray;
  border-radius: 5px;
  padding: 0 !important;
}

.large-widget {
  height: 45vh;
  overflow: auto;
  border-bottom: 2px solid gray;
  border: 1px solid gray;
  border-radius: 5px;
  margin: 10px 25px;
  background-color: white;
}

.user_warning {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.drop-allowed.drop-in * {
  cursor: inherit !important;
}
</style>
